import AddressVerificationScreen from 'features/personalDetails/screens/AddressVerification/AddressVerificationScreen';
import React from 'react';

export default function AddressVerificationPage() {
  return <AddressVerificationScreen />;
}
